module.exports = __webpack_public_path__ + "93fd0c06c62615b5704a7f8e3d81e642.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/icon/tv.svg
// module id = 2043
// module chunks = 0